module.exports = __webpack_public_path__ + "img/pdf-svgrepo-com.c919d52c.svg";